
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import HomePage from "./pages/HomePage";
import HomePage2 from "./pages/HomePage2";
import KitConsultingPage from "./pages/KitConsultingPage";
import AvisoLegalPage from "./pages/AvisoLegalPage";
import PoliticaPrivacidadPage from "./pages/PoliticaPrivacidadPage";
import PoliticaCookiesPage from "./pages/PoliticaCookiesPage";
import NotFound from "./pages/NotFound";
import { scrollToTop } from "./utils/navigation";

// ScrollToTop component that will handle scrolling to top on route changes
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    scrollToTop();
  }, [pathname]);
  
  return null;
};

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage2 />} />
          <Route path="/home-antigua" element={<HomePage />} />
          <Route path="/kit-consulting" element={<KitConsultingPage />} />
          <Route path="/aviso-legal" element={<AvisoLegalPage />} />
          <Route path="/politica-privacidad" element={<PoliticaPrivacidadPage />} />
          <Route path="/politica-cookies" element={<PoliticaCookiesPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
